/* =============================================
   Collections Mobile — Swiper Init
   File: assets/custom-collections-mobile.js

   Initialises one independent Swiper per
   collection row. slidesPerView: 'auto' lets
   each card use its natural CSS width.
   ============================================= */

(function () {

  function initCollectionsMobile() {
    const swipers = document.querySelectorAll('.cm-swiper');
    if (!swipers.length) return;

    swipers.forEach(function (swiperEl) {
      if (swiperEl.swiper) return; /* skip if already initialised */

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 44,
        grabCursor: true,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.6,
        },
        watchOverflow: true,
        a11y: { enabled: true },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionsMobile);
  } else {
    initCollectionsMobile();
  }

})();
